import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class IconRegistryService {
  constructor(
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer
  ) {}

  addSvgIcons() {
    const folder = 'assets/sharp';
    const iconDefinitions = {
      chat: `${folder}/sharp-chat-24px.svg`,
      close: `${folder}/sharp-close-24px.svg`,
      clear: `${folder}/sharp-clear-24px.svg`,
      more_vert: `${folder}/sharp-more_vert-24px.svg`,
      account_circle: `${folder}/sharp-account_circle-24px.svg`,
      dashboard: `${folder}/sharp-dashboard-24px.svg`,
      keyboard_arrow_left: `${folder}/sharp-keyboard_arrow_left-24px.svg`,
      keyboard_arrow_right: `${folder}/sharp-keyboard_arrow_right-24px.svg`,
      list: `${folder}/sharp-list-24px.svg`,
      map: `${folder}/sharp-map-24px.svg`,
      notifications: `${folder}/sharp-notifications-24px.svg`,
      settings: `${folder}/sharp-settings-24px.svg`,
      table_chart: `${folder}/sharp-table_chart-24px.svg`,
      cancel: `${folder}/sharp-cancel-24px.svg`,
      home: `${folder}/sharp-home-24px.svg`,
      assignment: `${folder}/sharp-assignment-24px.svg`,
      domain: `${folder}/sharp-domain-24px.svg`,
      people: `${folder}/sharp-people-24px.svg`,
      insert_chart: `${folder}/sharp-insert_chart-24px.svg`,
      build: `${folder}/sharp-build-24px.svg`,
      filter_list: `${folder}/sharp-filter_list-24px.svg`,
      view_list: `${folder}/sharp-view_list-24px.svg`,
      add: `${folder}/sharp-add-24px.svg`,
      exit_to_app: `${folder}/sharp-exit_to_app-24px.svg`,
      lock: `${folder}/sharp-lock-24px.svg`,
      person: `${folder}/sharp-person-24px.svg`,
      visibility: `${folder}/sharp-visibility-24px.svg`,
      visibility_off: `${folder}/sharp-visibility_off-24px.svg`,
      edit: `${folder}/sharp-edit-24px.svg`,
      delete: `${folder}/sharp-delete-24px.svg`,
      insert_file: `${folder}/sharp-insert_drive_file-24px.svg`,
      location: `${folder}/sharp-location-24px.svg`,
      contacts: `${folder}/sharp-contacts-24px.svg`,
      format_list_bulleted: `${folder}/sharp-format_list_bulleted-24px.svg`,
      assignment_turned_in: `${folder}/sharp-assignment_turned_in-24px.svg`,
      timer: `${folder}/sharp-timer-24px.svg`,
      arrow_drop_down: `${folder}/sharp-arrow_drop_down-24px.svg`,
      search: `${folder}/sharp-search-24px.svg`,
      check: `${folder}/sharp-check-24px.svg`,
      access_time: `${folder}/sharp-access_time-24px.svg`,
      payment: `${folder}/sharp-payment-24px.svg`,
      alarm: `${folder}/alarm-24px.svg`,
      work: `${folder}/work-24px.svg`,
      car: `${folder}/car-24px.svg`,
      break: `${folder}/break-24px.svg`,
      archive: `${folder}/archive-24px.svg`,
      input: `${folder}/sharp-input-24px.svg`,
      info: `${folder}/info-24px.svg`,
      view: `${folder}/remove_red_eye-24px.svg`,
      contact_phone: `${folder}/contact_phone-24px.svg`,
      salaries: `${folder}/attach_money-24px.svg`,
      expand_more: `${folder}/expand_more-24px.svg`,
      expand_less: `${folder}/expand_less-24px.svg`,
      copy: `${folder}/file_copy-24px.svg`,
      sort: `${folder}/sharp-sort.svg`
    };
    Object.keys(iconDefinitions).forEach(key => {
      this.iconRegistry.addSvgIcon(
        key,
        this.sanitizer.bypassSecurityTrustResourceUrl(iconDefinitions[key])
      );
    });
  }
}
